import React from "react";
import { Link, useParams } from "react-router-dom";
import Markdown from "react-markdown";

import { useSinglePost } from "../custom-hooks";
import { readableDate } from "../helper";
import "./SinglePost.scss";

export default function SinglePost() {
  const { id } = useParams();
  const [post, isLoading] = useSinglePost(id);

  const renderPost = () => {
    if (isLoading) return <p>Page Not Found!<br/>Check if the URL is correct.</p>;

    return (
      <div>
        <div className="intro">
          <div className='title'>
            <h2>{post.title}</h2>
            <small className='date'>{readableDate(post.date)}</small>
          </div>
          <p>{post.description}</p>

          <img src={post.link} alt={post.title}/>
        </div>

        <div className="body">
          <Markdown>{post.details}</Markdown>
        </div>
      </div>
    );
  };

  return (
    <div className="post-container">
      <Link className="back" to="/">
        {"< Back"}
      </Link>

      {renderPost()}
    </div>
  );
}
